import {
  Card,
  Typography,
  Input,
  Button,
  Form,
  DatePicker,
  Divider,
  Select,
  Switch,
  Tooltip
} from "antd";
import { useState, useEffect, useCallback } from "react";
import { LeftOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import { changeLoader } from "../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

function AddSubscription() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();

  const [formItems, setFormItems] = useState([
    { orderType: "Qc", orderVolume: "", IsEnabled: false },
    { orderType: "QC & Payment", orderVolume: "", IsEnabled: false },
    { orderType: "Delivery", orderVolume: "", IsEnabled: false },
    { orderType: "Delivery & Payment", orderVolume: "", IsEnabled: false },
    { orderType: "QC, Delivery & Payment", orderVolume: "", IsEnabled: false },
  ]);
  const [subscriptiondata, setSubscriptiondata] = useState({});
  const [formData, setFormData] = useState({
    description_en: "",
    description_ar: "",
    description_enErr: "",
    description_arErr: "",
    planName_ar: "",
    planName_en: ""
  });

  const handleChangeFormItems = (key, value, index) => {
    setFormItems((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [key]: value } : item))
    );
  };

  const getSubscriptionData = useCallback(async () => {
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis?.MANAGE_SUBSCRIPTION.GET_SUBSCRIPTION_DETAIL + "/" + id, "get", {}, {}, true);
    let apiResponse = response?.data;
    if (apiResponse?.status === "SUCCESS") {
      setSubscriptiondata(apiResponse?.data);
    } else {
      // toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  }, [dispatch, id]);

  useEffect(() => {
    if (id) getSubscriptionData();
  }, [id, getSubscriptionData]);

  useEffect(() => {
    if (subscriptiondata && Object.keys(subscriptiondata).length > 0) {
      const english = subscriptiondata.locales?.find((item) => item.languageCode === "en");
      const arabic = subscriptiondata.locales?.find((item) => item.languageCode === "ar");

      setFormData((prev) => ({
        ...prev,
        description_en: english?.planDescription || "",
        description_ar: arabic?.planDescription || "",
        planName_en: english?.planName || "",
        planName_ar: arabic?.planName || "",
      }));

      form.setFieldsValue({
        subscriptionId: subscriptiondata.subscriptionId,
        planPrice: subscriptiondata.planPrice,
        planDuration: subscriptiondata.planDuration,
        planName_en: english?.planName || "",
        planName_ar: arabic?.planName || "",
        startDate: subscriptiondata.startDate ? dayjs(subscriptiondata.startDate) : null,
        endDate: subscriptiondata.endDate ? dayjs(subscriptiondata.endDate) : null,
        subscriptionServiceDetails: subscriptiondata.subscriptionServiceDetails,
        status: subscriptiondata.subscriptionStatus === "active",
      });
        if (Array.isArray(subscriptiondata.subscriptionServiceDetails)) {
        const updatedFormItems = formItems.map((item) => {
          const match = subscriptiondata.subscriptionServiceDetails.find(
            (detail) => detail.orderType === item.orderType
          );
          return {
            ...item,
            orderVolume: match?.orderVolume || "",
            IsEnabled: !!match,
          };
        });
        setFormItems(updatedFormItems);
      }
      
    }
}, [subscriptiondata]);

  const submitHandler = async () => {
    try {
        const values = await form.validateFields();

        if (!formItems.length) {
          return toast.error("At least one service is required.");
        }
        const activeServices = formItems.filter(
          (item) => item.IsEnabled && Number(item.orderVolume) > 0
        );

        if (activeServices.length === 0) {
          return toast.error("At least one active service with volume > 0 is required.");
        }

        const subscriptionServiceDetails = formItems
        .filter((item) => item.IsEnabled)
        .map((item) => ({
          orderType: item.orderType,
          orderVolume: item.orderVolume,
          status: item.IsEnabled ? "Active" : "Inactive"
        }));
        const locales = [
        {
          languageCode: "en",
          planName: values.planName_en,
          planDescription: formData.description_en,
        },
        {
          languageCode: "ar",
          planName: values.planName_ar,
          planDescription: formData.description_ar,
        },
      ];

      const payload = {
        subscriptionId: values.subscriptionId,
        planName: values.planName_en,
        planPrice: Number(values.planPrice),
        planDuration: values.planDuration,
        startDate: values.startDate?.toISOString() || null,
        endDate: values.endDate?.toISOString() || null,
        subscriptionServiceDetails,
        subscriptionStatus: values.status,
        locales,
      };
      let url = Apis?.MANAGE_SUBSCRIPTION?.ADD_SUBSCRIPTION;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_SUBSCRIPTION?.EDIT_SUBSCRIPTION + "/" + id;
        method = "put";
      }

      const response = await globalRequest(
        url,
        method,
        payload,
        {},
        true
      );

      const apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Subscription created successfully";
        if (id) msg = "Subscription updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-subscription");
      } else {
        toast.error(apiResponse?.message);
      } 
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Card>
      <div className="flex items-center gap-2 mb-4">
        <LeftOutlined onClick={() => navigate(-1)} className="cursor-pointer" />
        {id ? <Typography className="text-xl font-semibold">Edit Subscription</Typography> : <Typography className="text-xl font-semibold">Add Subscription</Typography>}
      </div>
      <Divider />
      <Form form={form} layout="vertical">
        {/* <Box> */}
       <div className="grid grid-cols-1 sm:grid-cols-1 gap-4 w-[60%]">
        <Form.Item
          label="Subscription ID"
          name="subscriptionId"
          rules={[{ required: true, message: "Subscription ID is required" }]}
        >
          <Input placeholder="Enter Subscription ID" />
        </Form.Item>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4"> 
          <Form.Item
            label="Plan Name in English"
            name="planName_en"
            rules={[{ required: true, message: "Plan Name is required (EN)" }]}
          >
            <Input placeholder="Enter Plan Name" />
          </Form.Item>
          <Form.Item label="Plan Name in Arabic" 
            name="planName_ar"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Plan Name" />
          </Form.Item>
        </div>
        {/* Plan Description in English */}
        <div className="editor-height mb-3">
          <div className="flex items-center justify-between">
            <Typography className="text-lg font-semibold mb-4" align="left">
              Plan Description in English
              <span className="text-[#ff4d4f]">*</span>
            </Typography>
          </div>
          <CKEditor
            editor={ClassicEditor}
            data={formData?.description_en || ""}
            onChange={(event, editor) => {
              const data = editor.getData();
              setFormData((prev) => ({
                ...prev,
                description_en: data,
              }));
            }}
          />
          {formData?.description_enErr && (
            <span className="text-[#ff4d4f]">{formData?.description_enErr}</span>
          )}
        </div>

        {/* Plan Description in Arabic */}
        <div className="editor-height mb-3">
          <div className="flex items-center justify-between">
            <Typography className="text-lg font-semibold mb-4" align="left">
              Plan Description in Arabic
              <span className="text-[#ff4d4f]">*</span>
            </Typography>
          </div>
          <CKEditor
            editor={ClassicEditor}
            data={formData?.description_ar || ""}
            onChange={(event, editor) => {
              const data = editor.getData();
              setFormData((prev) => ({
                ...prev,
                description_ar: data,
              }));
            }}
          />
          {formData?.description_arErr && (
            <span className="text-[#ff4d4f]">{formData?.description_arErr}</span>
          )}
        </div>
        <Form.Item
          label="Plan Price"
          name="planPrice"
          rules={[{ required: true, message: "Plan Price is required" }]}
        >
          <Input placeholder="Enter Price" />
        </Form.Item>

        <Form.Item
          label="Plan Duration"
          name="planDuration"
          rules={[{ required: true, message: "Plan Duration is required" }]}
        >
          <Select placeholder="Select Plan Duration">
            <Select.Option value="monthly">Monthly</Select.Option>
            <Select.Option value="yearly">Yearly</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Status"
          name="status"
          rules={[
            {
              required: true,
              message: "Please select the status.",
            },
          ]}
        >
          <Switch
            checked={form.getFieldValue("status")}
            checkedChildren="active"
            unCheckedChildren="inactive"
            onChange={(checked) => {
              form.setFieldsValue({ status: checked ? "active" : "inactive" });
            }}
          />
          <Tooltip title="This will allow the admin to assign it to a subscription if enabled">
            <InfoCircleOutlined className="ml-4" />
          </Tooltip>
        </Form.Item>
       </div>

        <div className="flex gap-10">
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: true, message: "Start Date is required" }]}
          >
            <DatePicker />
          </Form.Item>

          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: true, message: "End Date is required" }]}
          >
            <DatePicker />
          </Form.Item>
           
        </div>
        <Typography className="text-lg font-semibold mt-6 mb-2">Services Offered</Typography>

        <div className="overflow-x-auto">
          <table className="min-w-full table-auto bg-white rounded-md">
            <thead className="bg-white">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">ID</th>
                <th className="px-4 py-2 text-left ">Order Type</th>
                <th className="px-4 py-2 text-left ">Order Volume</th>
                <th className="px-4 py-2 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {formItems.map((item, index) => (
                <tr key={index} className="border-t">
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.id || "-"}
                    </td>
                  <td className="px-4 py-2">{item.orderType}</td>
                  <td className="px-4 py-2">
                    <Input
                      type="number"
                      min={1}
                      value={item.orderVolume}
                      onChange={(e) =>
                        handleChangeFormItems("orderVolume", e.target.value, index)
                      }
                      disabled={!item.IsEnabled}
                      className="w-[50%] no-spinner"
                    />
                  </td>
                  <td className="px-4 py-2">
                    <input
                      type="checkbox"
                      checked={item.IsEnabled}
                      style={{backgroundColor: "#176B53"}}
                      onChange={(e) =>
                        handleChangeFormItems("IsEnabled", e.target.checked, index)
                      }
                      className="w-4 h-4 bg-[#176B53] hover:bg-none"
                    />{" "}
                    <span className="ml-2">{item.IsEnabled ? "Active" : "Inactive"}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end gap-3 mt-6">
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={submitHandler}>
            {id ? "Update" : "Create"} Subscription
          </Button>
        </div>
      </Form>
    </Card>
  );
}

export default AddSubscription;
